import { useState } from "react";
import { HiCog, HiOutlineDotsVertical, HiPlusCircle, HiRefresh } from "react-icons/hi";
import { useParams } from "react-router-dom";
import { setSimulation } from "../../../../redux/slices/timeline";
import store from "../../../../redux/store";
import { MenuDropdown } from "../../../../shared/atoms/MenuDropdown/MenuDropdown";
import Breadcrumb from "../../../../shared/molecules/Breadcrumb/Breadcrumb";
import Skeleton from "../../../../shared/molecules/Skeleton/Skeleton";
import CreateStrategyMapDrawer from "../../../CreateStrategyMap/CreateStrategyMapDrawer";
import SimulationToggle from "../../../SimulationToggle/SimulationToggle";
import * as def from "../../StrategyMapView.def";
import { StrategyMapViewSimFlag } from "../StrategyMapViewSimFlag/StrategyMapViewSimFlag";
import "./StrategyMapViewHeader.css";

export function StrategyMapViewHeader({state}: {state: def.StrategyMapViewStateProps}) {
  
    const { strategymap_id } = useParams();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [drawerTab, setDrawerTab] = useState(0);

    return (
      <div className="strategymap-view-header">
        <Breadcrumb
          items={[
            { label: "Strategy Maps", link: "/strategymaps" },
            {
              label: state.get.loadingSingleStrategyMap ? (
                <Skeleton variant="text" width={150} height={30} />
              ) : (
                state.get.strageyMapData?.name
              ),
            },
          ]}
        />

        <div className="flex gap-2 items-center px-4">
          <StrategyMapViewSimFlag state={state} onViewChanges={()=>{
            state.set((pv: any) => ({ ...pv, simulation: true }));
          }} onBackToLive={()=>{
            state.set((pv: any) => ({ ...pv, simulation: false }));
          }} />
          <SimulationToggle
            simFlag={state.get.simulation}
            onToggle={() => {
              state.set((pv: any) => ({ ...pv, simulation: !pv.simulation }));
              store.dispatch(setSimulation(!state.get.simulation));
            }}
          ></SimulationToggle>

          <button
            onClick={() => {
              setDrawerTab(1);
              setIsDrawerOpen(true);
            }}
            className={`flex items-center gap-1 text-light-text-inverse px-3 sm:px-4 py-1.5 sm:py-2 rounded-md text-sm focus:outline-none duration-200 shadow-md hover:shadow-lg transition-all ${"bg-primary-light dark:bg-primary-dark hover:bg-primary-hover dark:hover:bg-primary-light"}`}
          >
            <HiPlusCircle className="text-base sm:text-lg" />
            <span className="hidden lg:inline">Link Items</span>
            <span className="lg:hidden">Link Items</span>
          </button>
          <button
            onClick={() => {
              state.set((pv: any) => ({
                ...pv,
                hardRefreshKey: pv.hardRefreshKey + 1,
              }));
            }}
            className={`flex items-center gap-1 text-light-text-inverse px-3 sm:px-4 py-1.5 sm:py-2 rounded-md text-sm focus:outline-none duration-200 shadow-md hover:shadow-lg transition-all bg-light-text-secondary dark:bg-slate-600 hover:bg-light-text-secondary/80 dark:hover:bg-slate-700`}
          >
            <HiRefresh className="text-base sm:text-lg" />
            <span className="hidden lg:inline">Refresh Data</span>
            <span className="lg:hidden">Refresh</span>
          </button>

          <MenuDropdown
            trigger={
              <button className="p-1.5 sm:p-2 text-light-text-secondary rounded-full hover:bg-light-interactive-hover dark:hover:bg-slate-700 focus:outline-none flex-shrink-0 transition-colors duration-200">
                <HiOutlineDotsVertical className="text-lg sm:text-xl" />
              </button>
            }
            items={[
              {
                label: "Edit Strategy Map",
                icon: <HiCog />,
                onClick: () => {
                  setDrawerTab(0);
                  setIsDrawerOpen(true);
                },
              },
            ]}
          />

          <CreateStrategyMapDrawer
            isVisible={isDrawerOpen}
            onClose={() => setIsDrawerOpen(false)}
            strategyMapId={strategymap_id}
            defaultTab={drawerTab}
            onSuccess={() => {
              state.set((pv: any) => ({
                ...pv,
                refreshKey: pv.refreshKey + 1,
              }));
            }}
          />
        </div>
      </div>
    );
}